import { ITireManufacturer } from 'app/shared/model/tire-manufacturer.model';
import { ICompany } from 'app/shared/model/company.model';

export interface ITireModel {
  id?: number;
  name?: string | null;
  specification?: string | null;
  groove?: number | null;
  type?: string | null;    
  tireManufacturer?: ITireManufacturer | null;
  company?: ICompany | null;
}

export const defaultValue: Readonly<ITireModel> = {};